export default __webpack_public_path__ + "static/media/1232n.c88bbc0f.svg";